"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _rebrand = require("../../icons-react/rebrand");
var _constants = require("./constants");
var CounterPluralize = function CounterPluralize(_ref) {
  var value = _ref.value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    _ref$minValue = _ref.minValue,
    minValue = _ref$minValue === void 0 ? 0 : _ref$minValue,
    _ref$maxValue = _ref.maxValue,
    maxValue = _ref$maxValue === void 0 ? 25 : _ref$maxValue,
    _ref$buttonSize = _ref.buttonSize,
    buttonSize = _ref$buttonSize === void 0 ? 25 : _ref$buttonSize,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 16 : _ref$fontSize,
    _ref$fontWeight = _ref.fontWeight,
    fontWeight = _ref$fontWeight === void 0 ? 500 : _ref$fontWeight,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    _ref$zeroValueText = _ref.zeroValueText,
    zeroValueText = _ref$zeroValueText === void 0 ? '' : _ref$zeroValueText,
    className = _ref.className;
  var resultValue = value < 0 ? 0 : Number(value);
  var resultMinus = resultValue - step;
  var resultPlus = resultValue + step;
  var isMinusDisabled = resultMinus < minValue;
  var isPlusDisabled = resultPlus > maxValue;
  var counterText = zeroValueText.length ? zeroValueText : "".concat(resultValue, " ").concat(text);
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Button, {
    $buttonSize: buttonSize,
    disabled: isMinusDisabled,
    onClick: function onClick() {
      return onChange(resultMinus);
    },
    type: "button",
    "data-testid": _constants.MINUS_BUTTON_TEST_ID
  }, /*#__PURE__*/_react["default"].createElement(_rebrand.Minus, {
    height: 20
  })), /*#__PURE__*/_react["default"].createElement(Counter, {
    $fontSize: fontSize,
    $fontWeight: fontWeight,
    "data-testid": _constants.COUNTER_TEST_ID
  }, counterText), /*#__PURE__*/_react["default"].createElement(Button, {
    $buttonSize: buttonSize,
    disabled: isPlusDisabled,
    onClick: function onClick() {
      return onChange(resultPlus);
    },
    type: "button",
    "data-testid": _constants.PLUS_BUTTON_TEST_ID
  }, /*#__PURE__*/_react["default"].createElement(_rebrand.Plus, {
    height: 20
  })));
};
var Container = _styledComponents["default"].div.withConfig({
  displayName: "CounterPluralize__Container",
  componentId: "sc-do6kal-0"
})(["display:flex;align-items:center;justify-content:space-between;"]);
var Counter = _styledComponents["default"].span.withConfig({
  displayName: "CounterPluralize__Counter",
  componentId: "sc-do6kal-1"
})(["color:var(--black);font-size:", "px;font-weight:", ";white-space:pre;"], function (_ref2) {
  var $fontSize = _ref2.$fontSize;
  return $fontSize;
}, function (_ref3) {
  var $fontWeight = _ref3.$fontWeight;
  return $fontWeight;
});
var Button = _styledComponents["default"].button.withConfig({
  displayName: "CounterPluralize__Button",
  componentId: "sc-do6kal-2"
})(["display:flex;align-items:center;justify-content:center;flex:0 0 ", "px;aspect-ratio:1;border:none;cursor:pointer;--background-color:var(--background);background-color:var(--background-color);border-radius:var(--border-radius);:hover:enabled{background:linear-gradient(0deg,rgba(0,0,0,var(--hover-alpha)) 0%,rgba(0,0,0,var(--hover-alpha)) 100%),var(--background-color);}:active:enabled{background:linear-gradient(0deg,rgba(0,0,0,var(--pressed-alpha)) 0%,rgba(0,0,0,var(--pressed-alpha)) 100%),var(--background-color);}:disabled{cursor:default;opacity:var(--disabled-opacity);}"], function (_ref4) {
  var $buttonSize = _ref4.$buttonSize;
  return $buttonSize;
});
var _default = exports["default"] = CounterPluralize;